export enum CONFIG_KEYS {
	NEWS_LETTER_SUBSCRIPTION_ENABLED = 'newsletterSubscriptionEnabled',
	ANALYTICS_ENABLED = 'analyticsEnabled',
	POSTERS_ENABLED = 'postersEnabled',
	TRACK_ORDER_ENABLED = 'trackOrderEnabled',
	CUSTOM_PAGES_ENABLED = 'customPagesEnabled',
	MAX_CUSTOM_PAGES = 'maxCustomPages',
	TELEGRAM_BOT_ENABLED = 'telegramBotEnabled',
	MULTI_CURRENCY_ENABLED = 'multiCurrencyEnabled',
	SUPPORTED_CURRENCIES = 'supportedCurrencies',
}
